const Questions = [
	{
		id: '1',
		text: 'Summarize your problem in a one-line title',
	},
	{
		id: '2',
		text: 'Describe your problem in more details',
	},

	{
		id: '3',
		text: 'Describe what you tried and what you expected to happen',
	},

	{
		id: '4',
		text: 'Add “tags” which help surface your question to member of the community',
	},
	{
		id: '5',
		text: 'Review your question and post it to the site',
	},
];

export default Questions;
